import React, { useState, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { useAuthenticatedImage } from '../hooks/useAuthenticatedImage';

const InstituteLogoImage = ({ 
  logo, 
  size = 'medium',
  className = '', 
  width, 
  height, 
  roundedCircle = false,
  onClick,
  onError,
  onLoad,
  style,
  ...props 
}) => {
  const [imageError, setImageError] = useState(false);

  // Use authenticated image hook
  const { 
    imageSrc, 
    isLoading, 
    hasError 
  } = useAuthenticatedImage(
    logo,
    size,
    {
      fallbackSrc: '/images/default-institute-logo.svg',
      enabled: !!logo && !imageError,
      onLoad: () => {
        setImageError(false);
        if (onLoad) onLoad();
      },
      onError: (error) => {
        console.error('InstituteLogoImage: Logo failed to load:', logo, error);
        setImageError(true);
        if (onError) onError();
      }
    }
  );

  // Reset image error when logo changes
  useEffect(() => {
    setImageError(false);
  }, [logo]);

  const handleError = () => {
    console.error('InstituteLogoImage: Logo failed to load:', logo);
    setImageError(true);
    if (onError) onError();
  };

  const handleLoad = () => {
    setImageError(false);
    if (onLoad) onLoad();
  };
  
  // Determine the final image source
  const finalImageSrc = hasError || imageError ? '/images/default-institute-logo.svg' : imageSrc;
  
  return (
    <Image
      src={finalImageSrc}
      className={`${className} ${isLoading ? 'opacity-75' : ''}`}
      width={width}
      height={height}
      roundedCircle={roundedCircle}
      onClick={onClick}
      onError={handleError}
      onLoad={handleLoad}
      style={{
        transition: 'opacity 0.2s ease-in-out',
        ...style
      }}
      {...props}
    />
  );
};

export default InstituteLogoImage;
